import { render, staticRenderFns } from "./EditManagementHistory.vue?vue&type=template&id=c1bb0eb0&scoped=true&"
import script from "./EditManagementHistory.vue?vue&type=script&lang=js&"
export * from "./EditManagementHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bb0eb0",
  null
  
)

export default component.exports